// @flow

import PageContainer from '../common/PageContainer';
import { topBarHeight } from '../../components/navigation/NavigationBar';
import { useTheme } from '@mui/material';

const AGROLOG_QUOTE_TOOL_URL = 'https://quote.agrolog.io/';

const QuoteTool = (): React$Node => {
  const theme = useTheme();

  return (
    <PageContainer>
      <iframe
        src={`${AGROLOG_QUOTE_TOOL_URL}`}
        style={{
          width: '100%',
          height: `calc(${window.innerHeight}px - ${theme.spacing(topBarHeight + 2)})`,
          border: 0
        }}
      />
    </PageContainer>
  );
};

export default QuoteTool;
